import { useSession } from 'next-auth/react';
import { getTenantId } from '../utils/accountHelper';

export default function useSWRCacheKeys(url: string): string[] {
    const { data: session } = useSession();

    if (!session) {
        console.debug('No session found session:', session, 'will not do the request to', url);
        return null;
    }

    const isAbleToMakeRequest = Boolean(session?.userInfo?.username && session?.tenantId && url);

    return isAbleToMakeRequest ? [url, session?.userInfo?.username, session?.tenantId] : null;
}

function usePublicApiSWRCacheKeys(url: string): string[] {
    const tenantId = getTenantId();

    const isAbleToMakeRequest = Boolean(tenantId && url);

    return isAbleToMakeRequest ? [url, tenantId] : null;
}

export { usePublicApiSWRCacheKeys };
